<a [routerLink]="homePath" [attr.id]="inHeader ? 'header-logo' : null" class="app-logo">
	<img *ngIf="!isBO" style="width: 150px" src="shared-assets/images/ecarpa-logo.png" alt="Logo" />
	<img *ngIf="isBO" style="width: 150px" src="shared-assets/images/emdf-logo.png" alt="Logo" />
</a>
